import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, submit } from './modules'
import Loading from 'components/Loading'
import { languageChange, checkIsLogin } from 'store/siteConfig'

export default function(route) {
  const SmartCode = Loadable({
    loader: () => import('./SmartCode'),
    render(loaded, props) {
      const Component = connect((state) => ({
        smartCodeState: state.smartCodeState,
        siteConfig: state.siteConfig
      }), {
        init,
        submit,
        checkIsLogin,
        languageChange
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path='/smartcode/:code'
      render={(routeProps) => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <SmartCode {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
